import { Controller } from "@hotwired/stimulus"

// "Add entry" rows for a repeatable-entries form section (see
// Forms::Base.repeatable_entries and forms/_repeatable_entries.html.slim).
// Mounted on the section's wrapper div so multiple sections on one form stay
// independent. Rows post as <form>[<key>][<index>][<sub_key>]; indexes only
// need to be unique, so the counter starts past the highest server-rendered
// index and never reuses one — a Turbo cache restore can resurrect
// non-contiguous indexes after a remove-then-add, where length-based counting
// would hand out a duplicate and merge two rows into one on save.
export default class extends Controller {
  static targets = ["rows", "row", "template"]

  connect() {
    const indexes = this.rowTargets.map(row => this.#rowIndex(row)).filter(i => i !== null)
    this.nextIndex = indexes.length ? Math.max(...indexes) + 1 : 0
  }

  add() {
    const html = this.templateTarget.innerHTML.replaceAll("__INDEX__", this.nextIndex++)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
    this.rowTargets.at(-1).querySelector("input[type='text']")?.focus()
  }

  remove(event) {
    event.currentTarget.closest("[data-repeatable-entries-target='row']").remove()
    // DOM removal fires no native event; tell form-autosave the form changed.
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }

  #rowIndex(row) {
    const name = row.querySelector("input[name]")?.name
    const match = name?.match(/\[(\d+)\]/)
    return match ? Number(match[1]) : null
  }
}
